import React from 'react';
import PropTypes from 'prop-types';

import Page from 'zoomforth_zf/models/page.js';

import PageAccessibilityDisplay from 'zoomforth_shared_management/components/page_accessibility_display.jsx';
import PublishNotificationUI from './publish_notification.ui.jsx';

const PageDefaultPublishNotification = ({ page, onEditVisitorAccessClick }) => (
  <PublishNotificationUI title="Your changes are now live.">
    <PageAccessibilityDisplay
      onVisitorAccessSettingsView={onEditVisitorAccessClick}
      showAuthorizedEmails={false}
      page={page}
    />
  </PublishNotificationUI>
);

PageDefaultPublishNotification.propTypes = {
  page: PropTypes.instanceOf(Page).isRequired,
  onEditVisitorAccessClick: PropTypes.func.isRequired
};

export default PageDefaultPublishNotification;
